/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_TitleInputs */

const en_simple_home_banner_title = /** @type {(inputs: Simple_Home_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a programmer? Bystep builds it for you.`)
};

const id_simple_home_banner_title = /** @type {(inputs: Simple_Home_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan programmer? Bystep bangunkan untuk kamu.`)
};

/**
* | output |
* | --- |
* | "Not a programmer? Bystep builds it for you." |
*
* @param {Simple_Home_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_title = /** @type {((inputs?: Simple_Home_Banner_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_title(inputs)
	return en_simple_home_banner_title(inputs)
});